//FuelPolicyAutocomplete

import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"
import { BACKEND_APIS } from "@constants"
import FuelPolicyAutocomplete from "Pages/ReportsAlerts/Reports/@components/FuelPolicy"


export default function ReportFuelPolicyField() {
	const {
		idFuelPolicyFilter,
		setIdFuelPolicyFilterInfo,
		error
	} = useReportFormInfo(reportFormData.peek().idFuelPolicyFilter, "idFuelPolicyFilter", object({ idFuelPolicyFilter: string().nullable() }))

	return <FuelPolicyAutocomplete
		value={idFuelPolicyFilter}
		onChange={e => setIdFuelPolicyFilterInfo(e.target.value)}
		error={error}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/fuel`}
	/>
}